import { Modal, Button, Box, SpaceBetween } from '@amzn/awsui-components-core';
import {
  ContentWorkflow,
  UserRoles,
  WorkflowEventTypes,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { createWorkflowEventWithStatePolling } from '../../api/CreateWorkflowEventWithStatePolling';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import FlashbarMessageBroker from '../../common/FlashbarMessageBroker';
import { withAppContext } from '../../contexts/AppContext';
import AppContextProps from '../../contexts/AppContextProps';
import BrowserHistory from '../utils/BrowserHistory';

interface Props extends AppContextProps {
  contentId: string;
}

interface State {
  isModalVisible: boolean;
  isSendingUnpublishEvent: boolean;
  workflow?: ContentWorkflow;
}

class UnpublishButton extends React.Component<Props, State> {
  private mplServiceClient: IMplServiceClient;
  private flashbarMessageBroker: FlashbarMessageBroker;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.flashbarMessageBroker = FlashbarMessageBroker.create();
    this.state = {
      isModalVisible: false,
      isSendingUnpublishEvent: false,
    };
  }

  public async componentDidMount() {
    const { contentId } = this.props;
    const { authnInfo } = this.props.appContext;
    if (
      [UserRoles.Admin, UserRoles.TechWriter, UserRoles.Publisher].some((role) =>
        // @ts-expect-error TS18048 - strict migration
        authnInfo.userProfile.roles.has(role),
      )
    ) {
      const response = await this.mplServiceClient.getContentWorkflow(contentId);

      this.setState({
        workflow: response.workflow,
      });
    }
  }

  public render() {
    const { authnInfo } = this.props.appContext;

    if (
      ![UserRoles.Admin, UserRoles.TechWriter, UserRoles.Publisher].some((role) =>
        // @ts-expect-error TS18048 - strict migration
        authnInfo.userProfile.roles.has(role),
      )
    ) {
      return null;
    }

    const { isModalVisible, isSendingUnpublishEvent, workflow } = this.state;

    const modalContent = (
      <div>
        Unpublishing a content will remove the currently published version of the content.
        <br />
        It will still be available to the author content list.
        <br />
        <br />
        Are you sure you want to unpublish this content?
      </div>
    );

    const modalFooter = (
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="normal" onClick={this.closeModal}>
            {constants.CANCEL_BUTTON_TEXT}
          </Button>
          <Button variant="primary" loading={isSendingUnpublishEvent} onClick={this.unpublish}>
            {constants.CONFIRM_UNPUBLISH_BUTTON_TEXT}
          </Button>
        </SpaceBetween>
      </Box>
    );

    return (
      <Box padding={{ top: 's' }}>
        <Button variant="primary" onClick={this.openModal} disabled={!workflow}>
          {constants.UNPUBLISH_BUTTON_TEXT}
        </Button>
        <Modal
          header={constants.UNPUBLISH_ACTION_MODAL_HEADER}
          visible={isModalVisible}
          footer={modalFooter}
          onDismiss={() => this.setState({ isModalVisible: false })}
          closeAriaLabel="Close modal"
        >
          {modalContent}
        </Modal>
      </Box>
    );
  }

  private openModal = () => {
    this.setState({
      isModalVisible: true,
    });
  };

  private closeModal = () => {
    this.setState({
      isModalVisible: false,
    });
  };

  private unpublish = async () => {
    const { contentId } = this.props;
    const { workflow } = this.state;

    try {
      this.setState({
        isSendingUnpublishEvent: true,
      });
      await createWorkflowEventWithStatePolling(
        contentId,
        // @ts-expect-error TS18048 - strict migration
        workflow.publicationWorkflowId,
        WorkflowEventTypes.UNPUBLISH,
        '',
      );
      this.flashbarMessageBroker.pushSuccessMessage(`Content has been unpublished successfully`);
    } catch (e) {
      this.flashbarMessageBroker.pushErrorMessage('Unpublish content failed');
    }

    this.setState({
      isSendingUnpublishEvent: true,
    });

    BrowserHistory.push('/');
  };
}

export default withAppContext(UnpublishButton);
